import { MouseEvent } from "react";
import { NavigateFunction, NavigateOptions, To } from "react-router-dom";

export const navigateOnModifiedClick = (
  event: MouseEvent,
  navigate: NavigateFunction,
  to: To,
  options?: NavigateOptions,
  modifiedClickHref?: string
) => {
  if (event.defaultPrevented) return;

  if ((event.ctrlKey || event.metaKey) && typeof to === "string") {
    window.open(modifiedClickHref ?? to, "_blank", "noopener,noreferrer");
    return;
  }

  navigate(to, options);
};
